import React from "react";

const ItalicIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9.33335 3.16797H7.83335M9.33335 3.16797H10.8334M9.33335 3.16797L6.66669 12.8346M6.66669 12.8346H5.16669M6.66669 12.8346H8.16669"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ItalicIcon;
